// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3-nec","list":"styles_list__11Gqu"};